import { type TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import { createDeepEqualSelector } from '@core/js/utils/redux.util';

import { TRootState } from '../types';

export const useSelector: TypedUseSelectorHook<TRootState> = (selector, equalityFn) => {
    const deepSelector = createDeepEqualSelector([selector], (data) => data);

    return useReduxSelector(deepSelector, equalityFn);
};
